import Layout from '@/layout';
var marketingRouter = {
  path: '/marketing',
  component: Layout,
  redirect: '/marketing/travel/content/list',
  name: 'Marketing',
  meta: {
    title: '营销',
    icon: 'clipboard'
  },
  children: [{
    path: 'content',
    name: 'Content',
    meta: {
      title: '公告内容',
      noCache: true
    },
    component: function component() {
      return import('@/views/content');
    },
    children: [{
      path: 'articleManager',
      name: 'articleManager',
      component: function component() {
        return import('@/views/content/article/list');
      },
      meta: {
        title: '文章管理',
        icon: 'clipboard'
      }
    }, {
      path: 'articleCreat/:id?',
      name: 'articleCreat',
      component: function component() {
        return import('@/views/content/article/edit');
      },
      meta: {
        title: '添加文章',
        noCache: true,
        activeMenu: "/marketing/content/articleManager"
      }
    }, {
      path: 'classifManager',
      name: 'classifManager',
      component: function component() {
        return import('@/views/content/articleclass/list');
      },
      meta: {
        title: '文章分类',
        icon: 'clipboard'
      }
    }]
  }, {
    path: 'travel',
    name: 'Travel',
    meta: {
      title: '旅居宣传',
      noCache: true
    },
    component: function component() {
      return import('@/views/content');
    },
    children: [{
      path: 'content/list',
      name: 'travelContentList',
      component: function component() {
        return import('@/views/marketing/travel/content/list');
      },
      meta: {
        title: '宣传管理',
        icon: 'clipboard'
      }
    }, {
      path: 'content/create/:id?',
      name: 'travelContentCreate',
      component: function component() {
        return import('@/views/marketing/travel/content/edit');
      },
      meta: {
        title: '添加宣传',
        noCache: true,
        activeMenu: "/marketing/travel/content/list"
      },
      hidden: true
    }, {
      path: 'destination/list',
      name: 'travelDestinationList',
      component: function component() {
        return import('@/views/marketing/travel/destination/list');
      },
      meta: {
        title: '旅游目的地',
        icon: 'clipboard'
      }
    }, {
      path: 'destination/create/:id?',
      name: 'travelDestinationCreate',
      component: function component() {
        return import('@/views/marketing/travel/destination/edit');
      },
      meta: {
        title: '添加旅居目的地',
        noCache: true,
        activeMenu: "/marketing/travel/destination/list"
      },
      hidden: true
    }, {
      path: 'healthWellness',
      name: 'healthWellness',
      component: function component() {
        return import('@/views/marketing/travel/healthWellness/index');
      },
      meta: {
        title: '康养推荐',
        icon: 'clipboard'
      }
    }]
  }, {
    path: 'hotRecommend',
    name: 'HotRecommend',
    component: function component() {
      return import('@/views/marketing/hotRecommend/index');
    },
    meta: {
      title: '热门推荐',
      icon: 'clipboard'
    }
  }, {
    path: 'homeBanner',
    name: 'HomeBanner',
    component: function component() {
      return import('@/views/marketing/homeBanner/index');
    },
    meta: {
      title: '首页轮播图',
      icon: 'clipboard'
    }
  }]
};
export default marketingRouter;